module.exports = __webpack_public_path__ + "static/media/main.ab21c1f1.jpg";